import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';
import { requireReviewSharingEnabled } from '@/routes/guards/reviewSharing';
import { SUPPLIER_SHARING_PERMISSIONS } from '@/modules/review-sharing/permissions';

export const actionCentreClientRoutes = [
  {
    path: 'action-centre',
    component: () => import('./ActionCentre.vue'),
    children: [
      {
        path: '',
        name: 'client-action-centre',
        redirect: { name: 'client-action-centre-connection' },
      },
      {
        path: 'connection',
        name: 'client-action-centre-connection',
        component: () => import('./connections/ConnectionsTab.vue'),
      },
      {
        path: 'remediation',
        name: 'client-action-centre-remediation',
        component: () => import('./remediations/RemediationsTab.vue'),
      },
      {
        path: 'reviews',
        name: 'client-action-centre-reviews',
        component: () => import('./reviews/ReviewsTab.vue'),
      },
      {
        path: 'review-sharing',
        name: 'client-action-centre-review-sharing',
        component: () => import('./review-sharing/ReviewSharingTab.vue'),
        beforeEnter: [requireReviewSharingEnabled],
        meta: {
          permissions: SUPPLIER_SHARING_PERMISSIONS,
        },
      },
      {
        path: 'invite',
        name: 'client-action-centre-invite',
        // Legacy emails may still deep-link to /action-centre/invite.
        // Invite is removed in Action Centre V2, so always redirect to connection.
        beforeEnter: () => ({ name: 'client-action-centre-connection' }),
        component: () => import('@/modules/invite/InviteListTab.vue'),
        meta: {
          permissions: [Permission.ClientsInvitesView, Permission.ClientsInvitesManage],
        },
      },
    ],
  },
] satisfies RouteRecordRaw[];

export const actionCentreSupplierRoutes = [
  {
    path: 'action-centre',
    component: () => import('./ActionCentre.vue'),
    children: [
      {
        path: '',
        name: 'supplier-action-centre',
        redirect: { name: 'supplier-action-centre-connection' },
      },
      {
        path: 'connection',
        name: 'supplier-action-centre-connection',
        component: () => import('./connections/ConnectionsTab.vue'),
      },
      {
        path: 'remediation',
        name: 'supplier-action-centre-remediation',
        component: () => import('./remediations/RemediationsTab.vue'),
      },
      {
        path: 'merge-requests',
        name: 'supplier-action-centre-merge-requests',
        component: () => import('./merges/MergeRequestTab.vue'),
      },
    ],
  },
] satisfies RouteRecordRaw[];
